import { Link } from 'react-router-dom';
import { categories } from '@/mocks/news';

const accentStyles = [
  { bar: 'bg-primary-500', icon: 'ri-earth-line' },
  { bar: 'bg-secondary-500', icon: 'ri-movie-2-line' },
  { bar: 'bg-accent-500', icon: 'ri-leaf-line' },
];

export default function CategoryQuick() {
  return (
    <section className="mt-10">
      <div className="mb-4 flex items-end justify-between">
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950">新闻分类</h2>
          <p className="mt-1 text-sm text-foreground-500">按主题快速进入对应频道，掌握你最关心的话题</p>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((category, i) => (
          <Link
            key={category.id}
            to={`/category/${category.id}`}
            className="group relative flex h-40 flex-col justify-end overflow-hidden rounded-lg border border-background-200"
          >
            <img
              src={category.cover}
              alt={category.name}
              title={`${category.name} - 爆料网新闻爆料`}
              className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 to-foreground-950/10" />
            <span className={`absolute left-0 top-0 h-full w-1.5 ${accentStyles[i].bar}`} />
            <div className="relative p-4">
              <div className="flex items-center gap-2 text-background-50">
                <i className={`${accentStyles[i].icon} text-lg`} />
                <h3 className="font-heading text-lg font-bold">{category.name}</h3>
              </div>
              <p className="mt-1 line-clamp-2 text-xs leading-5 text-background-50/80">{category.intro}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}